var _path, _path2, _path3;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import React from "react";
const SvgCameraOutline = _ref => {
  let {
    svgRef,
    title,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "4.823 5.883 14.331 11.102",
    fill: "none",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M18.5455 15.3636C18.5455 15.9159 18.0978 16.3636 17.5455 16.3636H6.45459C5.90231 16.3636 5.45459 15.9159 5.45459 15.3636V8.60512C5.45459 8.05283 5.90231 7.60512 6.45459 7.60512H9.13536C9.40837 7.60512 9.66952 7.49349 9.85818 7.29615L10.2805 6.85437C10.4692 6.65703 10.7303 6.54541 11.0033 6.54541H13.0631C13.332 6.54541 13.5896 6.65371 13.7777 6.84588L14.2268 7.30465C14.4149 7.49681 14.6725 7.60512 14.9414 7.60512H17.5455C18.0978 7.60512 18.5455 8.05283 18.5455 8.60512V15.3636Z",
    stroke: "#0084F8",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M12.0001 9.81824C10.797 9.81824 9.81824 10.797 9.81824 12.0001C9.81824 13.2031 10.797 14.1819 12.0001 14.1819C13.2031 14.1819 14.1819 13.2031 14.1819 12.0001C14.1819 10.797 13.2031 9.81824 12.0001 9.81824",
    stroke: "#0084F8"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M16.4211 10.4977C16.4211 10.799 16.1769 11.0432 15.8757 11.0432C15.5744 11.0432 15.3302 10.799 15.3302 10.4977C15.3302 10.1964 15.5744 9.95227 15.8757 9.95227C16.1769 9.95227 16.4211 10.1964 16.4211 10.4977Z",
    fill: "#0084F8"
  })));
};
const ForwardRef = /*#__PURE__*/React.forwardRef((props, ref) => /*#__PURE__*/React.createElement(SvgCameraOutline, _extends({
  svgRef: ref
}, props)));
export default __webpack_public_path__ + "static/media/CameraOutline.81ab8339.svg";
export { ForwardRef as ReactComponent };